import React from 'react';
import {
    Drawer,
    IconButton,
    Stack,
    Typography,
    Box,
    Button,
    Divider
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CheckIcon from '@mui/icons-material/Check';

import { FaLinkedin, FaGithub, FaEnvelope, FaItchIo } from 'react-icons/fa';
import { PiReadCvLogoLight } from "react-icons/pi";

import { useTranslation } from 'react-i18next';

export default function SocialDrawer() {
    const [open, setOpen] = React.useState(false);
    const { i18n, t } = useTranslation();

    const links = [
        {
            label: "LinkedIn",
            href: "https://www.linkedin.com/in/raimundo-gonzalez-larrain-2784358a/",
            icon: <FaLinkedin />
        },
        {
            label: "GitHub",
            href: "https://github.com/barracius",
            icon: <FaGithub />
        },
        {
            label: t('email'),
            href: "mailto:rjgonzalez6@gmail.com",
            icon: <FaEnvelope />
        },
        {
            label: "Itch.io",
            href: "https://barracius1.itch.io/",
            icon: <FaItchIo />
        }
    ];

    const languages = [
        { code: "en", label: "English" },
        { code: "es", label: "Español" }
    ];

    return (
        <>
            <Button
                onClick={() => setOpen((prev) => !prev)}
                variant="contained"
                className={`social-drawer-tab ${open ? "open" : ""}`}
                aria-label={open ? "Close menu" : "Open social and language menu"}
            >
                <MenuIcon className="social-drawer-tab-icon" />
            </Button>

            <Drawer
                anchor="right"
                open={open}
                onClose={() => setOpen(false)}
                slotProps={{
                    paper: {
                        className: "social-drawer-paper",
                    }
                }}
            >
                <Box className="social-drawer-content">
                    <Typography className="social-drawer-section-title">
                        {t('language')}
                    </Typography>

                    <Stack spacing={1} className="social-drawer-language-list">
                        {languages.map((language) => {
                            const selected = i18n.language.startsWith(language.code);

                            return (
                                <Button
                                    key={language.code}
                                    className={`social-drawer-language-button ${selected ? "selected" : ""}`}
                                    onClick={() => {
                                        i18n.changeLanguage(language.code);
                                        setOpen(false);
                                    }}
                                    startIcon={
                                        selected ? (
                                            <CheckIcon className="social-drawer-selected-icon" />
                                        ) : (
                                            <span className="social-drawer-language-spacer" />
                                        )
                                    }
                                >
                                    {language.label}
                                </Button>
                            );
                        })}
                    </Stack>

                    <Divider className="social-drawer-divider" />

                    <Typography className="social-drawer-section-title">
                        Social
                    </Typography>

                    <Stack spacing={1.2} className="social-drawer-links">
                        {links.map((item) => (
                            <Button
                                key={item.label}
                                className="social-drawer-button"
                                href={item.href}
                                target="_blank"
                                rel="noreferrer"
                                startIcon={<span className="social-drawer-icon">{item.icon}</span>}
                            >
                                <span className="social-drawer-button-label">{item.label}</span>
                            </Button>
                        ))}
                    </Stack>

                    <Divider className="social-drawer-divider" />

                    <Button
                        href={require('../../PDF/Raimundo_Gonzalez_' + i18n.resolvedLanguage + '.pdf')}
                        target={'_blank'}
                        rel={"noopener noreferrer"}
                        className={"social-drawer-button"}
                        startIcon={<PiReadCvLogoLight />}
                    >
                        <span className="social-drawer-button-label">{t('cv')}</span>
                    </Button>
                </Box>
            </Drawer>
        </>
    );
}